<template>
    <Component :is="variationComponents[slice.variation as keyof typeof variationComponents]" v-bind="props" />
</template>

<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {TestimonialsSlice} from '@prismicio-types';
    import TestimonialsColumns from './variations/TestimonialsColumns.vue';
    import TestimonialsDefault from './variations/TestimonialsDefault.vue';
    import TestimonialsGrid from './variations/TestimonialsGrid.vue';
    import TestimonialsSingle from './variations/TestimonialsSingle.vue';
    import TestimonialsSingleQuote from './variations/TestimonialsSingleQuote.vue';

    const props = defineProps(getSliceComponentProps<TestimonialsSlice>());

    const variationComponents = {
        default: TestimonialsDefault,
        testimonialsSingle: TestimonialsSingle,
        testimonialsColumns: TestimonialsColumns,
        testimonialsSingleQuote: TestimonialsSingleQuote,
        testimonialsGrid: TestimonialsGrid,
    };
</script>
